import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { getSubscription } from "@/services/subscription.service";
import { Subscription } from "@/types/subscription.types";

const placeholderSubscription: Subscription = {
  id: "placeholder",
  user: "",
  team_id: "",
  stripe_customer_id: "",
  stripe_status: "active",
  ends_at: Date.now() / 1000 + 3600, // an hour from now
  start_date: Date.now() / 1000,
  cycle_start_date: Date.now() / 1000,
  last_event_date: Date.now() / 1000,
  cancel_initiate: false,
  cancel_at: null,
  old_user: false,
  paid_seats: true,
  sandbox_user: false,
  subscription_plan: "placeholder_plan",
  plan_id: 0,
  is_failure_attempt: false,
  is_microsoft: true,
  is_gmail: false,
  total_credits: 1000,
  topup_credits: 0,
  subscription_credits: 1000,
  plan_name: "Placeholder Plan",
  interval: "month",
  plan_details: {
    id: "",
    name: "",
    monthly_price_id: "",
    yearly_price_id: "",
    casual_monthly_price_id: "",
    monthly_cost: "",
    montly_base_price: "",
    yearly_cost: "",
    no_of_seats: "",
    yearly_base_price: "",
    original_yearly: "",
    casual_monthly_cost: "",
    casual_base_price: "",
    monthly_seat_price: 0,
    yearly_seat_price: 0,
    casual_seat_price: 0,
    features: [],
  },
  module_user: true,
  modules: [],
  can_cancel: true,
  no_of_seats: 1,
  is_casual: false,
  is_ms_word_license: true,
};

export const useSubscription = (options?: Partial<UseQueryOptions<Subscription, Error>>) => {
  return useQuery({
    queryKey: ["subscription"],
    queryFn: getSubscription,
    retry: false,
    placeholderData: placeholderSubscription,
    ...options,
  });
};
